module.exports = __webpack_public_path__ + "img/zk.4fc2312c.svg";